import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  NANGO_CONNECTIONS_QUERY_KEY,
  type NangoConnectSessionRequest,
} from '../../contracts';
import { nangoClient } from '../../data/api/nango';

export function useMutateNangoConnectSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['NangoConnectSession'],
    mutationFn: async (body: NangoConnectSessionRequest = {}) => {
      const { data } = await nangoClient.createConnectSession(body);
      return data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [NANGO_CONNECTIONS_QUERY_KEY] });
    },
  });
}
